import * as React from 'react';
import { GroupByPanel } from '../../containers/group-by/components/group-by-panel';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { GroupByFieldState } from 'app/area/reports/containers/group-by/types-store';
import { ChartState } from 'app/area/reports/containers/chart/types-store';
import { 
  useActionCreators, 
  useLoadGroupByDefaultFieldsSelectionReportEffect, 
  useLoadInitialDataEffect, 
  useLoadSelectionTypesEffect, 
  useWorkingDefinitionSelectedGroupByFields 
} from 'app/area/reports/containers/group-by/hooks';
import { useSelectedLayoutType } from 'app/area/reports/containers/chart/hooks';

export interface SelectionGroupByContainerProps {
  api: ReportCommonApi;
  orderNumber: string;
  disabled: boolean;
  translation: any;
  groupByFieldState: GroupByFieldState;
  chartState: ChartState;
  isFrequencyReport?: boolean;
}

export const SelectionGroupByContainer = ({
  api,
  orderNumber,
  translation,
  disabled,
  groupByFieldState,
  chartState
}: SelectionGroupByContainerProps) => {

  const selectedGroupByFields = useWorkingDefinitionSelectedGroupByFields();

  const selectedLayoutType = useSelectedLayoutType();
  
  const layoutTypeConfig = !!chartState.layoutTypes
    && chartState.layoutTypes.find(lt => lt.type.v === selectedLayoutType?.value);

  const {
    loadGroupByFields,
    updateDefaultGroupByFields,
    addSelection,
    modifyGroupBySelections
  } = useActionCreators(api);

  useLoadInitialDataEffect(api);

  useLoadGroupByDefaultFieldsSelectionReportEffect(api);

  useLoadSelectionTypesEffect(api);

  return <GroupByPanel
    disabled={disabled}
    orderNumber={orderNumber}
    fetching={groupByFieldState.fetching}
    data={groupByFieldState}
    selectedGroupByFields={selectedGroupByFields}
    onLoadGroupByFields={loadGroupByFields}
    onUpdateDefaultGroupByFields={updateDefaultGroupByFields}
    onSelectGroupBy={addSelection}
    onModifyGroupBySelections={modifyGroupBySelections}
    translation={translation}
    maxSelectionCriteria={layoutTypeConfig?.maxSelectionCriteria}
  />;
};
